import request from '@/utils/request'
let baseURL = '/mall-settle';

// 获得用户结算收益汇总数据
export function getUserEarnStat(data) {
  return request({
    url: '/api/earn/v1/getUserEarnStat',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
earnTypes (Array[string]): 收益类型：PLATFORM_MEMBER-平台会员收益；SHOP_MEMBER-店铺会员收益 ,
shopId (integer, optional): 店铺会员收益时需传店铺ID
}
*/

// 获得用户结算收益明细---废弃
export function listEarnDetails(data) {
  return request({
    url: '/api/earn/v1/listEarnDetails',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
earnType (string, optional): 收益类型大类：PLATFORM_MEMBER-平台会员收益；SHOP_MEMBER-店铺会员收益；AGENT_SHOP-分销店铺收益；GOODS_SHARE-邀请下单收益；SHOP_INCOME-店铺收入；VAT-增值税；INDIVIDUAL_INCOME_TAX-个人所得税 = ['VAT', 'PLATFORM_MEMBER', 'PLATFORM_PROFIT', 'SHOP_MEMBER', 'AGENT_SHOP', 'GOODS_SHARE', 'SHOP_INCOME', 'INDIVIDUAL_INCOME_TAX'],
page (integer, optional),
shopId (integer, optional): 店铺会员收益时需传店铺ID ,
size (integer, optional),
userId (string, optional): 用户OPENID
}
*/


// 获取会员分润奖励日志记录（分页）
export function getMemberEarnLogs(params) {
  return request({
    url: '/EarnLog/v1/getMemberEarnLogs',
    method: 'get',
    baseURL,
    params
  })
}


// 获取下单金币奖励日志记录（分页）
export function getOrderRewardLogs(params) {
  return request({
    url: '/EarnLog/v1/getOrderRewardLogs',
    method: 'get',
    baseURL,
    params
  })
}
/*
tabs
列表页签，SETTLED-已结算；WAIT_SETTLE-待结算（全部）
* */


// 获取各种钱包待结算的总额
export function getWaitSettle(params) {
  return request({
    url: '/GetWaitSettle/v1/getWaitSettle',
    method: 'get',
    baseURL,
    params
  })
}
/*
targetId
收益者ID，个人钱包是userOpenid，如果是店铺钱包则是shopid

query	string
targetType
收益者类型，0：个人，1：店铺

query	integer
walletType
钱包类型，REWARD-奖金余额；SERVICE-服务余额；ANTCOIN-金币；空为全部
query	string
* */

// 用户金币奖励统计
export function getUserGoldStat(params) {
  return request({
    url: '/api/earn/v1/getUserGoldStat',
    method: 'get',
    baseURL,
    params
  })
}

// 用户金币奖励统计
export function userSettleGold(params) {
  return request({
    url: '/api/earn/v1/userSettleGold',
    method: 'get',
    baseURL,
    params
  })
}
